<!--
  A progress bar that states its own denominator.

  "Resolved" means boxed **or** explicitly marked not-present. An annotator who has recorded
  that a letter OCIANA reads is not on the stone has finished with that letter, and a bar that
  keeps counting it as outstanding is quietly pressuring them to invent a box.
-->
<script lang="ts">
  import { percent } from '../lib/progress';

  interface Props {
    label: string;
    value: number;
    total: number;
    detail?: string;
    tone?: 'accent' | 'ok';
  }

  const { label, value, total, detail = '', tone = 'accent' }: Props = $props();
  const pct = $derived(percent(value, total));
</script>

<div class="meter">
  <div class="row small">
    <span>{label}</span>
    <span class="spacer"></span>
    <span class="mono">{value}/{total}</span>
  </div>
  <div
    class="track"
    role="progressbar"
    aria-valuenow={value}
    aria-valuemin="0"
    aria-valuemax={total}
    aria-label={label}
  >
    <div class="fill {tone}" style:width={`${pct}%`}></div>
  </div>
  {#if detail}
    <div class="small muted">{detail}</div>
  {/if}
</div>

<style>
  .meter {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  .track {
    height: 8px;
    background: var(--bg-input);
    border: 1px solid var(--line);
    border-radius: 4px;
    overflow: hidden;
  }

  .fill {
    height: 100%;
    background: var(--accent);
    transition: width 120ms linear;
  }

  .fill.ok {
    background: var(--ok);
  }
</style>
